import { GetCustomerGroups } from "../queries/GetCustomerGroups.core.js";
export const getCustomerGroups = async ({ first }, { client }) => {
    const pageSize = 100;
    const maxItems = first ?? Number.POSITIVE_INFINITY;
    const groups = [];
    let after;
    while (groups.length < maxItems) {
        const currentPageSize = Math.min(pageSize, maxItems - groups.length);
        const data = (await client.core.request(GetCustomerGroups, {
            first: currentPageSize,
            after,
        }));
        if (!data?.customerGroups) {
            break;
        }
        if (data.customerGroups.__typename !== "CustomerGroupConnection") {
            throw new Error(`Error fetching customer groups. Unexpected typename: ${data.customerGroups.__typename}`);
        }
        const currentGroups = data.customerGroups.edges
            ?.map((edge) => edge.node)
            .filter((group) => Boolean(group.identifier))
            .map((group) => ({
            identifier: group.identifier,
            name: group.name ?? group.identifier,
        })) ?? [];
        groups.push(...currentGroups);
        if (!data.customerGroups.pageInfo.hasNextPage) {
            break;
        }
        after = data.customerGroups.pageInfo.endCursor ?? undefined;
        if (!after) {
            break;
        }
    }
    return groups;
};
